import React, {useEffect} from 'react';
import {useLoggedIn} from "../../store";
import {useBaseCommunity} from "../../store/hooks";

/* eslint-disable func-names */
const TwitterTrackingPixel = () => {
    const loggedIn = useLoggedIn();
    const baseCommunity = useBaseCommunity().toLowerCase();
    useEffect(() => {
        try {
            if (!loggedIn && baseCommunity !== "thedonald") {
                !function (e, t, n, s, u, a) {
                    e.twq || (s = e.twq = function () {
                        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
                    }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = 'https://static.ads-twitter.com/uwt.js', a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a));
                }(window, document, 'script');

                window.twq('config', 'ol6jl');
            }
        } catch (error) {
        }
    }, []);

    return null;
};

export default TwitterTrackingPixel;
